if (!window._menuEventListenerAdded) {
  document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener(
      "click",
      function (e) {
        const el = e.target.closest("[data-gtm-event]");
        if (!el) return;
        try {
          window.dataLayer = window.dataLayer || [];
          const event = el.getAttribute("data-gtm-event") || "NA";
          const sectionName = el.getAttribute("data-section-name") || "NA";
          const position = el.getAttribute("data-position") || "NA";
          const ctaText = el.getAttribute("data-cta-text") || "NA";
          const selectionType = el.getAttribute("data-selection-type") || "NA";

          if (event === "logo_click") {
            window.dataLayer.push({
              event: "logo_click",
              position_event: position,
            });
          }
          if (
            event === "top_navigation_click" ||
            event === "footer_navigation_click"
          ) {
            const subSectionName =
              el.getAttribute("data-menu-subsection") || "NA";
            const cta = el.getAttribute("data-menu-cta") || "NA";

            window.dataLayer.push({
              event: event,
              position_event: position,
              section_name: sectionName,
              sub_section_name: subSectionName,
              cta_text: cta,
            });
          }
          if (event === "product_category_click") {
            window.dataLayer.push({
              event: "product_category_click",
              section_name: sectionName || "NA",
              cta_text: ctaText,
            });
          }
          if (event === "search_term_entered") {
            var searchInput = document.querySelector(
              "input[data-input-search]"
            );
            var searchInputMobile = document.querySelector(
              "input[data-input-search-mobile]"
            );

            const searchTermData =
              el.getAttribute("data-search-term");

            const searchTerm =
              window.innerWidth <= 768
                ? searchInputMobile?.value
                : searchInput?.value;

            window.dataLayer.push({
              event: "search_term_entered",
              section_name: sectionName,
              selection_type: selectionType,
              search_term: searchTermData || searchTerm,
            });
          }
          if (event === "cta_link_click") {
            const ctaType = el.getAttribute("data-cta-type") || "NA";

            window.dataLayer.push({
              event: "cta_link_click",
              section_name: sectionName,
              position_event: position,
              cta_text: ctaText,
              cta_type: ctaType,
            });
          }
          if (event === "filter_applied") {
            window.dataLayer.push({
              event: "filter_applied",
              section_name: sectionName,
              cta_text: ctaText,
            });
          }
          if (event === "sort_applied") {
            window.dataLayer.push({
              event: "sort_applied",
              section_name: sectionName,
              cta_text: ctaText,
            });
          }
        } catch (e) {
          console.error("Error in event listener", e);
        }
      },
      true
    );

    // Mobile Menu Drawer Event Listener Start
    const menuDrawer = document.getElementById("menu_mobile");
    if (menuDrawer && menuDrawer.shadowRoot) {
      const closeBtn = menuDrawer.shadowRoot.querySelector(
        'wrapp-close-btn button[aria-label="Close"]'
      );
      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "top_navigation_click",
            position_event: "hamburger",
            section_name: "NA",
            sub_section_name: "NA",
            cta_text: "menu_close",
          });
        });
      }
    }
    // Mobile Menu Drawer Event Listener End

    // Search Event Listener Start
    var searchForm = document.querySelector("form[data-frm-search]");
    var searchFormMobile = document.querySelector(
      "form[data-frm-search-mobile]"
    );
    var searchInput = document.querySelector("input[data-input-search]");
    var searchInputMobile = document.querySelector(
      "input[data-input-search-mobile]"
    );

    if (searchForm && searchInput) {
      searchForm.addEventListener("submit", function (e) {
        const searchTerm = searchInput.value;
        window.dataLayer = window.dataLayer || [];
        if (searchTerm && searchTerm !== "") {
          window.dataLayer.push({
            event: "search_term_entered",
            section_name: "search",
            selection_type: "manual",
            search_term: searchTerm,
          });
        }
      });
    }

    if (searchFormMobile && searchInputMobile) {
      searchFormMobile.addEventListener("submit", function (e) {
        const searchTerm = searchInputMobile.value;

        window.dataLayer = window.dataLayer || [];
        if (searchTerm && searchTerm !== "") {
          window.dataLayer.push({
            event: "search_term_entered",
            section_name: "search",
            selection_type: "manual",
            search_term: searchTerm,
          });
        }
      });
    }
    // Search Event Listener End

    // Back in Stock Form Event Listener Start
    const observeBackInStockForm = () => {
      const notifyForm = document.querySelector(
        '[data-form="back-in-stock-form"]'
      );
      if (notifyForm && !notifyForm._gtmListenerAdded) {
        notifyForm.addEventListener("submit", function (e) {
          const emailInput = notifyForm.querySelector(
            'input[name="contact[email]"]'
          );
          const sectionName =
            emailInput.getAttribute("data-product-name") || "NA";
          if (!emailInput || !emailInput.checkValidity()) return;
          setTimeout(() => {
            const buttonText =
              notifyForm
                .querySelector('button[type="submit"]')
                ?.innerText.trim() || "NA";
            window.dataLayer.push({
              event: "cta_link_click",
              section_name: sectionName,
              position_event: "NA",
              cta_text: buttonText,
              cta_type: "button",
            });
          }, 500);
        });
        notifyForm._gtmListenerAdded = true;
      }
    };

    const observer = new MutationObserver(observeBackInStockForm);
    observer.observe(document.body, { childList: true, subtree: true });
    observeBackInStockForm();
    // Back in Stock Form Event Listener End

    // // Contact Form Event Listener
    // const trackedForms = document.querySelectorAll("[data-gtm-form-event]");

    // trackedForms.forEach((formElement) => {
    //   formElement.addEventListener("submit", function () {
    //     if (!formElement.checkValidity()) return;

    //     const formSectionName =
    //       formElement.getAttribute("data-section-name") || "NA";

    //     setTimeout(() => {
    //       const trackedFields = Array.from(
    //         formElement.querySelectorAll("input, textarea, select")
    //       )
    //         .filter((field) => {
    //           const isHiddenField =
    //             field.type === "hidden" || field.type === "submit";
    //           const hasValue = field.value && field.value.trim() !== "";
    //           return !isHiddenField && hasValue;
    //         })
    //         .map((field) => field.getAttribute("data-label") || "NA");

    //       window.dataLayer = window.dataLayer || [];
    //       window.dataLayer.push({
    //         event: "form_field_interaction",
    //         section_name: formSectionName,
    //         selection_type: trackedFields.join(", "),
    //       });
    //     }, 500);
    //   });
    // });

    // Contact Form Event Listener
    const trackedForms = document.querySelectorAll("[data-gtm-form-event]");

    trackedForms.forEach((formElement) => {
      const formSectionName =
        formElement.getAttribute("data-section-name") || "NA";

      // ✅ 1. Track field interactions (only when field has value and user leaves it)
      formElement
        .querySelectorAll("input, textarea, select")
        .forEach((field) => {
          if (field.type === "hidden" || field.type === "submit") return;

          field.addEventListener("change", () => {
            const value = field.value.trim();
            if (!value) return; // Skip empty fields

            const selectionType = field.getAttribute("data-label") || "NA";

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "form_field_interaction",
              section_name: formSectionName,
              selection_type: selectionType,
            });
          });
        });

      // ✅ 2. Track "Send" button click
      const sendButton = formElement.querySelector('[type="submit"]');
      if (sendButton) {
        sendButton.addEventListener("click", (e) => {
          // Optional: Validate form before sending event
          if (!formElement.checkValidity()) return;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "form_field_interaction",
            section_name: formSectionName,
            selection_type: "Send",
          });
        });
      }
    });
    // Contact Form Event Listener End
  });

  window._menuEventListenerAdded = true;
}
